<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدیریت میزان آگاهی از مقررات و استانداردها</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label fw-bold">نوع</label>
          <select class="form-select" v-model="newItem.type">
            <option value="" disabled>انتخاب نوع</option>
            <option v-for="(type, index) in types" :key="index" :value="type">
              {{ type }}
            </option>
          </select>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-bold">عنوان</label>
          <input
              type="text"
              class="form-control"
              placeholder="عنوان را وارد کنید"
              v-model="newItem.title"
          />
        </div>
        <div class="col-md-3">
          <label class="form-label fw-bold">وضعیت</label>
          <select class="form-select" v-model="newItem.status">
            <option value="" disabled>وضعیت</option>
            <option v-for="(status, index) in statuses" :key="index" :value="status">
              {{ status }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['نوع', 'عنوان', 'وضعیت']"
          :fields="['type', 'title', 'status']"
          :items="rules"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          title="ویرایش میزان آگاهی"
          modal-id="ruleModalId"
          @save="updateItem"
      >
        <div class="row mb-3 justify-content-center">
          <div class="col-md-4">
            <label class="form-label fw-bold">نوع</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.type">
              <option value="" disabled>نوع را انتخاب کنید</option>
              <option v-for="(type, index) in types" :key="index" :value="type">
                {{ type }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">عنوان</label>
            <input
                type="text"
                class="form-control"
                placeholder="عنوان را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.title"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">وضعیت</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.status">
              <option value="" disabled>وضعیت را انتخاب کنید</option>
              <option v-for="(status, index) in statuses" :key="index" :value="status">
                {{ status }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";
import {useToast} from "vue-toastification";

const baseStructure = {
  type: '',
  title: '',
  status: '',
};

const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/rules/index',
      afterMutation: 'rules/setRules'
    });
  },
  data() {
    return {
      newItem: structuredClone(baseStructure),
      statuses: ['خیلی زیاد', 'زیاد', 'متوسط', 'کم', 'خیلی کم'],
      types: [
        'استانداردها',
        'قوانین کلان کشوری',
        'سیاست‌های ابلاغی',
        'دستورالعمل‌های داخلی',
      ],
      editedItem: null,
      editIndex: null,
    };
  },
  computed: {
    rules: {
      get() {
        return this.$store.state.rules.rules;
      },
      set(value) {
        this.$store.commit('rules/setRules', value);
      }
    },
  },
  methods: {
    async addItem() {
      if (!this.checkItemValidation(this.newItem)) {
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/rules/store',
      })

      this.rules = [...this.rules, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },
    removeItem(index) {
      const rule = this.rules.find((_, i) => i === index);
      this.rules = this.rules.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: rule.id,
        endpoint: '/rules/delete',
      })
    },
    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('ruleModalId'));
      modal.show();
    },
    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.checkItemValidation(this.editedItem)) {
        return;
      }

      this.rules.splice(this.editIndex, 1, { ...this.editedItem });

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/rules/update',
      })

        this.rules.splice(this.editIndex, 1, {...this.editedItem});
        this.editIndex = null;
        this.editedItem = null;
        const modal = Modal.getOrCreateInstance(document.getElementById('ruleModalId'));
        modal.hide();
    },
    checkItemValidation(item) {
      if (
          !item.type ||
          !item.title ||
          !item.status
      ) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return false;
      }
      return true;
    },
  }
};
</script>
